export default "__VITE_ASSET__hiXBnXup__"